module.exports = __webpack_public_path__ + "img/5.af6744ac.png";